/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Interior(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1671 3.41698C15.029 3.41707 15.8556 3.75972 16.465 4.36913C17.0743 4.97859 17.4171 5.80518 17.4171 6.66698V8.53808C17.7749 8.65505 18.105 8.85383 18.3761 9.12499C18.829 9.57816 19.0841 10.1933 19.0841 10.834V15C19.084 15.4198 18.9171 15.8233 18.6203 16.1201C18.3234 16.417 17.92 16.5839 17.5002 16.584H2.50015C2.08057 16.5839 1.67782 16.4167 1.38101 16.1201C1.08415 15.8233 0.91723 15.4198 0.917144 15V10.834C0.917144 10.193 1.17194 9.5782 1.62515 9.12499C1.89648 8.85366 2.22607 8.65502 2.58414 8.53808V6.66698C2.58414 5.80518 2.92602 4.97859 3.53531 4.36913C4.1448 3.75964 4.97218 3.41698 5.83414 3.41698H14.1671ZM16.6671 9.91698C16.424 9.91698 16.1906 10.0136 16.0187 10.1855C15.8469 10.3574 15.7502 10.5909 15.7502 10.834V11.667C15.75 12.0809 15.4141 12.4168 15.0002 12.417H5.00015C4.5862 12.4168 4.25033 12.0809 4.25015 11.667V10.834C4.25015 10.591 4.1533 10.3574 3.9816 10.1855C3.80986 10.0139 3.57694 9.91716 3.33414 9.91698C3.09102 9.91698 2.85761 10.0136 2.6857 10.1855C2.51379 10.3574 2.41714 10.5909 2.41714 10.834V15C2.41723 15.022 2.42601 15.044 2.44156 15.0596C2.45706 15.0748 2.4784 15.0839 2.50015 15.084H17.5002C17.5221 15.0839 17.5442 15.0751 17.5597 15.0596C17.5753 15.044 17.5841 15.022 17.5841 15V10.834C17.5841 10.5911 17.4872 10.3574 17.3156 10.1855C17.1437 10.0137 16.9101 9.91707 16.6671 9.91698ZM5.83414 4.91698C5.37008 4.91698 4.925 5.10159 4.59683 5.42968C4.26864 5.75787 4.08414 6.20286 4.08414 6.66698V8.53808C4.44183 8.65507 4.77203 8.85391 5.04312 9.12499C5.49593 9.57814 5.75015 10.1933 5.75015 10.834V10.917H9.25015V4.91698H5.83414ZM10.7502 10.917H14.2502V10.834C14.2502 10.1931 14.505 9.57819 14.9582 9.12499C15.2294 8.85373 15.5592 8.65504 15.9171 8.53808V6.66698C15.9171 6.20301 15.7324 5.75784 15.4044 5.42968C15.0763 5.10157 14.6312 4.91707 14.1671 4.91698H10.7502V10.917Z"
        fill="#35424F"
      />
    </svg>
  )
}

Interior.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Interior
